<template>
  <div
    class="basic-slider"
    :class="bem('basic-slider', { bounds: paginationVisible && bounds })"
  >
    <template v-if="showNavigation && slides.length > 1">
      <button
        class="basic-slider__button basic-slider__button--prev"
        ref="prev"
      >
        <span>{{ prevTitle }}</span>
        <SvgIcon color="muted-blue" size="24" icon="arrow" />
      </button>
      <button
        class="basic-slider__button basic-slider__button--next"
        ref="next"
      >
        <span>{{ nextTitle }}</span>
        <SvgIcon color="muted-blue" size="24" icon="arrow" />
      </button>
    </template>
    <div
      v-if="hasSlides"
      class="basic-slider__body swiper"
      ref="body"
    >
      <div class="basic-slider__slides swiper-wrapper">
        <div
          v-for="(slide, index) in slides"
          :key="index"
          class="swiper-slide"
          :class="bem('basic-slider__slide', { 'swiper-off': slides.length < 2 })"
        >
          <slot :slide="slide" />
        </div>
      </div>
    </div>
    <div
      v-if="paginationVisible"
      ref="pagination"
      class="swiper-pagination"
      :class="bem('swiper-pagination', { under: paginationUnder })"
    />
  </div>
</template>

<script>
  import 'swiper/scss';
  import Swiper from 'swiper';
  import { Navigation, Pagination } from 'swiper/modules';

  import { bem } from 'src/utils/bem.js';

  import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';

  export default {
    name: 'BasicSlider',
    components: {
      SvgIcon,
    },
    props: {
      slides: {
        type: Array,
      },
      prevTitle: {
        type: String,
        default: 'Назад',
      },
      nextTitle: {
        type: String,
        default: 'Вперед',
      },
      paginationUnder: Boolean,
      showPagination: {
        type: Boolean,
        default: true,
      },
      showNavigation: {
        type: Boolean,
        default: true,
      },
      spaceBetween: {
        type: Number,
        default: undefined,
      },
      disabled: Boolean,
      bounds: {
        type: String,
        default: null,
        validator: value => !value || ['with-pagination'].includes(value),
      }
    },
    emits: ['slideChange'],
    data() {
      return {
        currentIndex: 0,
      };
    },
    mounted() {
      this.initSwiper();
    },
    methods: {
      bem,
      initSwiper() {
        if (this.slides.length < 2) return;

        const options = {
          modules: [Navigation, Pagination],
          autoHeight: true,
          navigation: {
            nextEl: this.$refs.next,
            prevEl: this.$refs.prev,
          },
          pagination: this.showPagination && {
            el: this.$refs.pagination,
          },
          loop: true,
          slidesPerView: 1,
        };

        // потому что spaceBetween: undefined ломает свайпер пополам
        if (this.spaceBetween !== undefined) {
          options.spaceBetween = this.spaceBetween;
        }

        this.swiperInstance = new Swiper(this.$refs.body, options);

        this.swiperInstance.on('slideChange', ({ realIndex }) => {
          this.$emit('slideChange', realIndex);
          this.currentIndex = realIndex;
        });
      },
      next() {
        this.swiperInstance.slideNext();
      },
    },
    computed: {
      hasSlides() {
        return this.slides && this.slides.length;
      },
      paginationVisible() {
        return !!(this.showPagination && this.hasSlides && this.slides.length > 1);
      }
    },
  };
</script>
